import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import * as Crypto from 'expo-crypto'
import { ToastState, ShowToastPayload, ToastData } from './types'

const initialState: ToastState = {
  toasts: [],
}

const { actions, reducer } = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (state, action: PayloadAction<ShowToastPayload>) => {
      const id = Crypto.randomUUID()
      const newToast: ToastData = {
        id,
        ...action.payload,
        link: action.payload.link ? { ...action.payload.link } : undefined,
      }
      state.toasts.push(newToast)
    },
    hideToast: (state, action: PayloadAction<string>) => {
      const index = state.toasts.findIndex((toast) => toast.id === action.payload)
      if (index !== -1) {
        state.toasts.splice(index, 1)
      }
    },
    clearAllToasts: (state) => {
      state.toasts = []
    },
  },
})

export const toastActions = actions
export const toastReducer = reducer
export default reducer
